export const ENTRYPOINT = process.env.VUE_APP_BASE_API_URL
